import { render, staticRenderFns } from "./CartHead.vue?vue&type=template&id=531db7b0&scoped=true"
import script from "./CartHead.vue?vue&type=script&lang=js"
export * from "./CartHead.vue?vue&type=script&lang=js"
import style0 from "./CartHead.vue?vue&type=style&index=0&id=531db7b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531db7b0",
  null
  
)

export default component.exports